import React from 'react'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Loader from '../../components/ClinicLoader'
import {
  CLINIC_USER_ID,
  LOCAL_STORAGE_CLINIC_AUTH_KEY_NAME
} from '../../../Constants'
import { updateLocalStorage } from '../../../stores/Clinic/Auth'

const RedirectIframe = () => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(location.search)
    const id = urlSearchParams.get('id') || ''
    const token = urlSearchParams.get('token') || ''
    const patient_id = urlSearchParams.get('patient_id') || ''
    const doctor_id = urlSearchParams.get('doctor_id') || ''

    if (
      id.length > 0 &&
      token.length > 0 &&
      patient_id.length > 0 &&
      doctor_id.length > 0
    ) {
      localStorage.setItem('clinic_user_id', id)
      localStorage.setItem('clinic_auth_key', token)
      localStorage.setItem('clinic_booking_doctor_id', doctor_id)
      localStorage.setItem('clinic_booking_patient_id', patient_id)
      updateLocalStorage({
        id_token: token,
        hospital_details: { user_id: id }
      })
        .then(() => {
          history.replace('/clinic/booking')
        })
        .catch(console.error)
    } else alert('Bad Redirection')
  }, [location.search, history])

  return <Loader />
}

export default RedirectIframe
